export default "__VITE_ASSET__DiW4tCfa__"